import { roundOff } from "utils";

const hexToRgba = (x) => {
  const hex = parse(x);
  const head = hex.slice(0, 6);
  const tail = hex.slice(6);
  const n = parseInt(head, 16);
  return [(n >> 16) & 0xff, (n >> 8) & 0xff, (n >> 0) & 0xff, getAlpha(tail)];
};

const parse = (x = "") => {
  const hex = x.replace(/^#/, "");
  const len = hex.length;
  return len === 3 || len === 4 ? repeat(hex) : hex;
};

const repeat = (x) =>
  x
    .split("")
    .map((y) => y + y)
    .join("");

const getAlpha = (x) => (x ? parseFloat(roundOff(parseInt(x, 16) / 0xff)) : 1);

const rgbaToHex = ([r = 0, g = 0, b = 0, a = 1] = []) => {
  const rgbN = (1 << 24) | (r << 16) | (g << 8) | b;
  const hex = rgbN.toString(16).slice(1);
  const alpha = (a * 255).toString(16).padStart(2, "0").slice(0, 2);
  return `#${hex}${alpha}`;
};

export const hexToRgb = (hex) => {
  if (!hex) return { r: 0, g: 0, b: 0 };
  const normalized = hex.replace("#", "");
  const bigint = parseInt(
    normalized.length === 3
      ? normalized
          .split("")
          .map((c) => c + c)
          .join("")
      : normalized,
    16
  );
  return { r: (bigint >> 16) & 255, g: (bigint >> 8) & 255, b: bigint & 255 };
};

export const isLightColor = (color) => {
  const { r, g, b } = hexToRgb(color);
  return (r * 299 + g * 587 + b * 114) / 1000 >= 180;
};

export const getTextColor = (bg) => (isLightColor(bg) ? "#0f172a" : "#ffffff");

// Generates a dark-to-light blue gradient for n items (index 0 = darkest)
export const getHierarchicalColors = (count) => {
  const dark = { r: 30, g: 64, b: 175 }; // #1e40af
  const light = { r: 219, g: 234, b: 254 }; // #dbeafe
  return Array.from({ length: count }, (_, i) => {
    const t = count === 1 ? 0 : i / (count - 1);
    const r = Math.round(dark.r + (light.r - dark.r) * t);
    const g = Math.round(dark.g + (light.g - dark.g) * t);
    const b = Math.round(dark.b + (light.b - dark.b) * t);
    return `rgb(${r},${g},${b})`;
  });
};

export const lightenDarken = (direction, color) => {
  const rgb = hexToRgba(color).slice(0, 3);

  const rgbAdjusted =
    direction >= 0
      ? rgb.map((x) => (1 - direction) * x + direction * 255)
      : rgb.map((x) => (1 + direction) * x);

  return rgbaToHex(rgbAdjusted).slice(0, 7);
};
